var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_142)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18ZM7.41335 13.5648L14.7958 6.18239L14.7969 6.18354C14.927 6.05352 15 5.87718 15 5.6933C15 5.50943 14.927 5.33308 14.7969 5.20306C14.6669 5.07304 14.4906 5 14.3067 5C14.1228 5 13.9465 5.07304 13.8165 5.20306L6.92369 12.0947L4.18354 9.35453C4.11916 9.29015 4.04273 9.23908 3.95862 9.20424C3.8745 9.16939 3.78435 9.15146 3.6933 9.15146C3.60226 9.15146 3.5121 9.16939 3.42799 9.20424C3.34387 9.23908 3.26744 9.29015 3.20306 9.35453C3.13868 9.41891 3.08762 9.49533 3.05277 9.57945C3.01793 9.66356 3 9.75372 3 9.84477C3 9.93581 3.01793 10.026 3.05277 10.1101C3.08762 10.1942 3.13868 10.2706 3.20306 10.335L6.43288 13.5648C6.49717 13.6293 6.57358 13.6805 6.6577 13.7155C6.74183 13.7504 6.83202 13.7684 6.92311 13.7684C7.01421 13.7684 7.1044 13.7504 7.18853 13.7155C7.27265 13.6805 7.34906 13.6293 7.41335 13.5648Z",
    fill: "#24E9A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSuccess);
export default __webpack_public_path__ + "static/media/login_success.582954d2bcf9057642d3d10963e7b8f7.svg";
export { ForwardRef as ReactComponent };